import { render } from "./ProgramTrackListViewEditItemPane.vue?vue&type=template&id=def46cd4&scoped=true&ts=true"
import script from "./ProgramTrackListViewEditItemPane.vue?vue&type=script&lang=ts"
export * from "./ProgramTrackListViewEditItemPane.vue?vue&type=script&lang=ts"

import "./ProgramTrackListViewEditItemPane.vue?vue&type=style&index=0&id=def46cd4&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-def46cd4"]])

export default __exports__